<h1 matDialogTitle>Transfer Deposit</h1>

<mat-dialog-content>
  <mat-progress-bar *ngIf="busy" mode="indeterminate"></mat-progress-bar>

  <div style="flex-direction: column;box-sizing: border-box;display: flex;">


    <form class="dynamic-form" [formGroup]="searchForm" style="width: 100%;margin-top: 32px;">
      <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Store</mat-label>
          <mat-select formControlName="storeId">
            <mat-option *ngFor="let store of stores" [value]="store.storeId">
              {{store.storeName}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex="40" width="100%">
          <mat-label>From SO</mat-label>
          <input matInput type="text" formControlName="fromSalesOrderNumber">
        </mat-form-field>

        <mat-form-field fxFlex="40" width="100%">
          <mat-label>To SO</mat-label>
          <input matInput type="text" formControlName="toSalesOrderNumber">
        </mat-form-field>

        <div
          style="display: flex;align-content: center;align-items: center;flex-direction: column;flex-wrap: nowrap;justify-content: space-between;"
          fxFlex="20" width="100%">
          <button [disabled]="!searchForm.valid || busy" mat-button (click)="validate()">Validate</button>
        </div>
      </div>
    </form>

    <ng-container *ngIf="validateResponse">

      <div>
        <table style="width: 100%;">
          <tr>
            <th></th>
            <th class="th-label" style="text-align: right; font-weight: bold; text-decoration: underline;">
              {{validateResponse.fromSalesOrderNumber}}</th>
            <th class="th-label"
              style="text-align: right; font-weight: bold; text-decoration: underline; padding-right: 0px;">
              {{validateResponse.toSalesOrderNumber}}</th>
          </tr>
          <tr>
            <th class="th-label">Customer</th>
            <td class="td-value" style="text-align: right; padding-right: 16px;">{{validateResponse.fromCustomer}}</td>
            <td class="td-value" style="text-align: right;">{{validateResponse.toCustomer}}</td>
          </tr>
          <tr>
            <th class="th-label">Order Amount</th>
            <td class="td-value" style="text-align: right; padding-right: 16px;">{{validateResponse.fromOrderAmount
              |
              number:'1.2-2'}}</td>
            <td class="td-value" style="text-align: right;">{{validateResponse.toOrderAmount | number:'1.2-2'}}
            </td>
          </tr>
          <tr>
            <th class="th-label">Deposit Available</th>
            <td class="td-value" style="text-align: right; padding-right: 16px;">{{validateResponse.fromAvailalbeDeposit
              |
              number:'1.2-2'}}</td>
            <td class="td-value" style="text-align: right;">{{validateResponse.toAvailalbeDeposit | number:'1.2-2'}}
            </td>
          </tr>
          <tr>
            <th class="th-label">Deposit Required</th>
            <td class="td-value" style="text-align: right; padding-right: 16px;">{{validateResponse.fromRequiredDeposit
              |
              number:'1.2-2'}}</td>
            <td class="td-value" style="text-align: right;">{{validateResponse.toRequiredDeposit | number:'1.2-2' : ''}}
            </td>
          </tr>
          <tr>
            <th class="th-label">Invoice Balance</th>
            <td class="td-value" style="text-align: right; padding-right: 16px;">{{validateResponse.fromInvoiceBalance |
              number:'1.2-2'}}</td>
            <td class="td-value" style="text-align: right;">{{validateResponse.toInvoiceBalance | number:'1.2-2' : ''}}
            </td>
          </tr>
          <tr>
            <th class="th-label">Allowed to Transfer</th>
            <td class="td-value" style="text-align: right; padding-right: 16px;">
              {{validateResponse.fromAllowedToTransfer
              | number:'1.2-2'}}</td>
            <td class="td-value" style="text-align: right;">{{validateResponse.toAllowedToTransfer | number:'1.2-2' :
              ''}}
            </td>
          </tr>
        </table>
      </div>



      <ng-container *ngIf="validateResponse.transferAlllowed; else notAllowed">
        <form class="dynamic-form" [formGroup]="form" style="width: 100%;margin-top: 32px;">
          <div>
            <mat-form-field fxFlex="100" width="100%">
              <mat-label>Transfer Amount</mat-label>
              <input matInput style="text-align: right;" type="number" formControlName="amountToTransfer">
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxFlex="50" style="padding-right: 8px">
              <mat-label>Approved By Manager Email</mat-label>
              <input matInput type="email" formControlName="approvedByEmail" autocomplete="new-password">
            </mat-form-field>
            <mat-form-field fxFlex="50" style="padding-left: 8px">
              <mat-label>Approved By Manager Password</mat-label>
              <input matInput type="password" formControlName="approvedByPwd" autocomplete="new-password">
            </mat-form-field>
          </div>
        </form>
      </ng-container>
      <ng-template #notAllowed>

        <div style="background-color: #f31700a1;padding: 16px;border-radius: 5px;margin-top: 16px">
          {{validateResponse.transferAllowedMessage}}
        </div>

      </ng-template>
    </ng-container>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!validateResponse || !validateResponse.transferAlllowed || !form.valid || busy"
    (click)="save()">Save</button>
</mat-dialog-actions>